import api from 'api'
import { VoohCampaignsFilters, VoohCampaignsFiltersForm, voohFiltersFormDefault } from './types'
import { setLoading, setVoohCampaignsFilters } from './slice'
import { AppDispatch } from 'store'
import pick from 'lodash/pick'

export default class CampaignTableFiltersService {
  static getFilters = (dispatch: AppDispatch): void => {
    dispatch(setLoading(true))

    api.campaign
      .getCampaignFilters()
      .then(res => {
        const { cities, agencies, mediaFormats, statuses, buildings } = res.data.campaignFilters

        dispatch(
          setVoohCampaignsFilters({
            ...voohFiltersFormDefault,
            citiesAll: cities,
            agenciesAll: agencies,
            mediaFormatsAll: mediaFormats,
            statusesAll: statuses,
            buildingsAll: buildings,
          })
        )
      })
      .catch(() => void {})
      .finally(() => void dispatch(setLoading(false)))
  }

  static cleanFiltersForm = (
    previousFilters: VoohCampaignsFiltersForm,
    dispatch: AppDispatch
  ): void => {
    const { citiesAll, agenciesAll, mediaFormatsAll, statusesAll, buildingsAll } = previousFilters

    dispatch(
      setVoohCampaignsFilters({
        ...voohFiltersFormDefault,
        citiesAll,
        agenciesAll,
        mediaFormatsAll,
        statusesAll,
        buildingsAll,
      })
    )
  }

  static pickOnlyApiFilters = (filters: VoohCampaignsFiltersForm): VoohCampaignsFilters => {
    return pick(filters, [
      'cities',
      'agencies',
      'endDateFrom',
      'endDateTo',
      'mediaFormats',
      'startDateFrom',
      'startDateTo',
      'statuses',
      'text',
      'buildings',
      'brandOrNetworkSelected',
    ])
  }

  static areFiltersFetched = (filters: VoohCampaignsFiltersForm): boolean => {
    const { citiesAll, agenciesAll, mediaFormatsAll, statusesAll } = filters
    const {
      citiesAll: citiesAllDefault,
      agenciesAll: agenciesAllDefault,
      mediaFormatsAll: mediaFormatsAllDefault,
      statusesAll: statusesAllDefault,
    } = voohFiltersFormDefault

    return (
      citiesAll === citiesAllDefault &&
      agenciesAll === agenciesAllDefault &&
      mediaFormatsAll === mediaFormatsAllDefault &&
      statusesAll === statusesAllDefault
    )
  }
}
